import Swal from 'sweetalert2';

const BRAND = '#1ABB9C';
const DANGER = '#dc2626';

const toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    showCloseButton: true,
    timer: 3500,
    timerProgressBar: true,
    width: 'auto',
    customClass: { popup: 'swal-toast-popup', title: 'swal-toast-title' },
    didOpen: (t) => {
        t.addEventListener('mouseenter', Swal.stopTimer);
        t.addEventListener('mouseleave', Swal.resumeTimer);
    },
});

if (typeof document !== 'undefined' && !document.getElementById('swal-toast-style')) {
    const style = document.createElement('style');
    style.id = 'swal-toast-style';
    // Mensagem curta continua numa linha (width:'auto' encolhe o toast até ela);
    // mensagem longa quebra em vez de empurrar o toast além da viewport, que é o
    // que acontecia com white-space:nowrap nos erros vindos da API.
    style.innerHTML = `
        .swal-toast-popup { max-width: min(26rem, calc(100vw - 2rem)); }
        .swal-toast-title { white-space: normal; overflow-wrap: anywhere; text-align: left; padding-right: 1.5rem; }
    `;
    document.head.appendChild(style);
}

export const toastSuccess = (title) => toast.fire({ icon: 'success', title });
export const toastError = (title) => toast.fire({ icon: 'error', title });
export const toastWarning = (title) => toast.fire({ icon: 'warning', title });
export const toastInfo = (title) => toast.fire({ icon: 'info', title });

export const alertError = (text, title = 'Erro') =>
    Swal.fire({ icon: 'error', title, text, confirmButtonColor: BRAND, showCloseButton: true });

export const alertValidacao = (text, title = 'Dados inválidos') =>
    Swal.fire({ icon: 'warning', title, text, confirmButtonColor: BRAND, showCloseButton: true });

export const alertSuccess = (text, title = 'Sucesso') =>
    Swal.fire({ icon: 'success', title, text, confirmButtonColor: BRAND, showCloseButton: true });

export const confirmAcao = async ({
    title = 'Confirmar',
    text = 'Deseja continuar?',
    confirmButtonText = 'Confirmar',
    cancelButtonText = 'Cancelar',
    icon = 'question',
    danger = false,
} = {}) => {
    const result = await Swal.fire({
        title,
        text,
        icon,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText,
        cancelButtonText,
        confirmButtonColor: danger ? DANGER : BRAND,
        cancelButtonColor: '#6b7280',
        reverseButtons: true,
        focusCancel: danger,
    });
    return result.isConfirmed;
};

/**
 * Confirmação que exige um motivo escrito. Usada em correções financeiras e
 * clínicas: a API recusa estorno/retificação sem motivo, porque é o motivo que
 * torna a correção auditável depois.
 *
 * @returns o texto informado, ou null se o usuário desistir.
 */
export const pedirMotivo = async ({
    title = 'Informe o motivo',
    text = 'Descreva o motivo desta correção:',
    confirmButtonText = 'Confirmar',
    cancelButtonText = 'Cancelar',
    placeholder = 'Ex.: valor lançado errado, pagamento não identificado…',
    minimo = 5,
} = {}) => {
    const result = await Swal.fire({
        title,
        text,
        icon: 'warning',
        input: 'textarea',
        inputPlaceholder: placeholder,
        inputAttributes: { 'aria-label': title, maxlength: 500 },
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText,
        cancelButtonText,
        confirmButtonColor: DANGER,
        cancelButtonColor: '#6b7280',
        reverseButtons: true,
        inputValidator: (valor) => {
            if (!valor || valor.trim().length < minimo) {
                return `Descreva o motivo com pelo menos ${minimo} caracteres.`;
            }
            return null;
        },
    });
    return result.isConfirmed ? result.value.trim() : null;
};

/**
 * Reautenticação para operação sensível em registro clínico. A senha é usada
 * apenas para pedir a autorização temporária de uso único — não fica guardada.
 */
export const pedirSenha = async ({
    title = 'Confirme sua identidade',
    text = 'Esta operação altera registro clínico finalizado. Digite sua senha:',
    confirmButtonText = 'Confirmar',
} = {}) => {
    const result = await Swal.fire({
        title,
        text,
        icon: 'info',
        input: 'password',
        inputAttributes: { 'aria-label': title, autocomplete: 'current-password' },
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText,
        cancelButtonText: 'Cancelar',
        confirmButtonColor: BRAND,
        cancelButtonColor: '#6b7280',
        reverseButtons: true,
        inputValidator: (valor) => (valor ? null : 'Informe a senha.'),
    });
    return result.isConfirmed ? result.value : null;
};

export const confirmExclusao = ({ text = 'Esta ação não pode ser desfeita.', title = 'Confirmar exclusão' } = {}) =>
    confirmAcao({ title, text, icon: 'warning', confirmButtonText: 'Excluir', danger: true });

export default Swal;
